'use client';
export { ButtonFavorite } from './button-favorite';
